import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AdministratorProfileComponent } from './administrator/administrator-profile.component';
import { SingleBenefitsComponent } from './workflow/benefits/single-benefits.component';
import { TerminosCondicionesComponent } from './terminos-condiciones/terminos-condiciones.component';
import { DataBenefitResolverService } from './resolvers/databenefit.resolver.service';
import { CategoryResolverService } from './resolvers/datacateg.resolver.service';
import { BlankviewComponent } from './blankview/blankview.component';
import { GeneralBenefitsResolverService, TypeBeneficiariesResolverService } from './resolvers/datatypebenefit.resolver.service';
import { DetailPlansResolverService, EmployeeChangePlanResolver, EmployeePlanResolver, PlansResolverService } from './resolvers/dataplans.resolver.service';
import { EmployeeResolverService, terms_conditions_user_resolver } from './resolvers/dataemployee.resolver.service';
import { DataRequestResolverService } from './resolvers/datarequest.resolver.service';
import { DataRequestSolicitudIdResolverService } from './resolvers/datarequest_solicitudid.resolver.service';
import { SolicitudCompanyLoanComponent } from './solicitud-company-loan/solicitud-company-loan.component';
import { EmployeeSAPResolverService } from './resolvers/dataempleadosap.service';
import { termsGuard } from './auth/guards/auth.guard';
import { ViewEditFormComponent } from './workflow/benefit-application/employee-request-flow/view-edit-form/view-edit-form.component';
import { DataRequestHistoryResolverService } from './resolvers/datarequest_history.resolver.service';


const routes: Routes = [
  { path: 'home',
    canActivate: [termsGuard],
    component: BlankviewComponent,
   },
  {
    path: 'welcome',
    component: HomeComponent,
    canActivate: [termsGuard],
    resolve: {
      resolverBenefit: DataBenefitResolverService,
      resolverCategory: CategoryResolverService,
      resolverPlans: PlansResolverService,
      resolverTypeBenef: TypeBeneficiariesResolverService,
      resolverEmployee: EmployeeResolverService,
      resolve_user_plan: EmployeePlanResolver,
    },
  },
  { path: 'terminos', component: TerminosCondicionesComponent },
  { path: 'solicitud-companyLoan', component: SolicitudCompanyLoanComponent },
  { path: 'benefits', component: SingleBenefitsComponent, canActivate: [termsGuard], resolve:{resolve_user_plan: EmployeePlanResolver}, },
  {
    path: 'admin',
    component: AdministratorProfileComponent,
    children: [
      {
        path: 'reporte/seguro-complementario',
        loadChildren: () =>
          import('./workflow/tab-report-seg-salud/tab-report-seg-salud.module').then(
            (m) => m.TabReportSegSaludModule,
          ),
      },
      {
        path: 'profiles',
        loadChildren: () =>
          import('./workflow/tab-profiles/tab-profiles.module').then(
            (m) => m.TabProfilesModule,
          ),
      },
      {
        path: 'benefits',
        loadChildren: () =>
          import('./workflow/tab-benefits/tab-benefits.module').then(
            (m) => m.TabBenefitsModule,
          ),
          
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./workflow/tab-profiles/tab-profiles.module').then(
            (m) => m.TabProfilesModule,
          ),
      },
        {
        path: 'report/gym',
        loadChildren: () =>
          import('./workflow/tab-gym-report/tab-gym-report.module').then(
            (m) => m.TabGymReportModule,
          ),
      },
      {
        path: 'reports/benefits',
        loadChildren: () =>
          import('./workflow/tab-benefits-report/tab-benefits-report.module').then(
            (m) => m.TabBenefitsReportModule
          ),
          resolve: { 
          benefits: GeneralBenefitsResolverService
         },
      },
      {
        path: 'requests',
        loadChildren: () =>
          import('./workflow/tab-requests/tab-requests.module').then(
            (m) => m.TabRequestsModule,
          ),
      },
      {
        path: 'requests/benefit-application/:id',
        loadChildren: () =>
          import(
            './workflow/benefit-application/admin-request-flow/admin-request-flow.module'
          ).then((m) => m.AdminRequestFlowModule),

        resolve: { 
          resolver_request_id: DataRequestSolicitudIdResolverService,
          resolverPlans: PlansResolverService,
         },
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('./workflow/tab-categories/tab-categories.module').then(
            (m) => m.TabCategoriesModule,
          ),
      },
      {
        path: 'categories/edit-category',
        loadChildren: () =>
          import('./workflow/edit-category/edit-category.module').then(
            (m) => m.EditCategoryModule,
          ),
      },
      {
        path: 'categories/add-category',
        loadChildren: () =>
          import('./workflow/add-category/add-category.module').then(
            (m) => m.AddCategoryModule,
          ),
      },
      {
        path: 'benefits/add-benefit',
        loadChildren: () =>
          import('./workflow/add-benefit/add-benefit.module').then(
            (m) => m.AddBenefitModule,
          ),
      },
      {
        path: 'users/add-user',
        loadChildren: () =>
          import('./workflow/add-user/add-user.module').then(
            (m) => m.AddUserModule,
          ),
      },
      {
        path: 'users/edit-user',
        loadChildren: () =>
          import('./workflow/edit-user/edit-user.module').then(
            (m) => m.EditUserModule,
          ),
      },
      {
        path: 'mantenedores',
        loadChildren: () =>
          import('./workflow/mantenedores/mantenedores.module').then(
            (m) => m.MantenedoresModule,
          ),
      },
      {
        path: 'company-loan',
        loadChildren: () =>
          import('./workflow/tab-companyloan/tab-companyloan.module').then(
            (m) => m.TabCompanyloanModule,
          ),
      },
      {
        path: 'refund',
        loadChildren: () =>
          import('./workflow/tab-refund-falp/tab-refund-falp.module').then(
            (m) => m.TabRefundFalpModule,
          ),
          resolve: {
            resolverBenefit: DataBenefitResolverService,
          }
      },
      {
        path: 'refund/collective-falp',
        loadChildren: () =>
          import(
            './workflow/tab-refund-falp/collective-falp/collective-falp.module'
          ).then((m) => m.CollectiveFalpModule),
      },
      {
        path: 'health',
        loadChildren: () =>
          import('./workflow/credit-dental-health/credit-dental-health.module').then(
            (m) => m.CreditDentalHealthModule,
          ),
          resolve: {
            resolverBenefit: DataBenefitResolverService,
          }
      },
      {
        path: 'health/collective-dental-health',
        loadChildren: () =>
          import('./workflow/credit-dental-health/collective-dental-health/collective-dental-health.module').then(
            (m) => m.DentalhealthModule,
          ),
      },
      {
        path: 'health/collective-dental-health/dental-health-application/:id',
        loadChildren: () =>
          import('./workflow/credit-dental-health/collective-dental-health/dental-health-application/dental-health-application.module').then(
            (m) => m.DentalHealthAplicationModule,
          ),
          resolve: { resolver_request_id: DataRequestSolicitudIdResolverService },
      },
      {
        path: 'config/second-approver',
        loadChildren: () =>
          import('./workflow/tab-second-approver-configuration/tab-second-approver-configuration.module').then(
            (m) => m.TabSecondApproverConfigurationModule,
          ),
      },
      {
        path: 'requests/second-approver',
        loadChildren: () =>
          import('./workflow/tab-second-aprover-requests/tab-second-approver-requests.module').then(
            (m) => m.TabSecondApproverRequestsModule,
          ),
      },
      {
        path: 'historical-requests',
        loadChildren: () => 
          import('./workflow/tab-historical-requests/tab-historical-requests.module').then(
            (m) => m.TabHistoricalRequestsModule
          ),
          resolve: { 
          benefits: GeneralBenefitsResolverService
         },
      },
    ],
  },
  {
    path: 'beneficiaries-form',
    loadChildren: () =>
      import('./workflow/beneficiaries-form/beneficiaries-form.module').then(
        (m) => m.BeneficiariesFormModule,
      ),
      resolve: {
        resolver_plans: PlansResolverService,
        resolve_user_plan: EmployeePlanResolver,
        resolverBenefit: DataBenefitResolverService,
        resolverEmpleadoSAP:EmployeeSAPResolverService
      }
  },
  {
    path: 'successful-request',
    loadChildren: () =>
      import(
        './workflow/beneficiaries-form/success-view/success-view.module'
      ).then((m) => m.SuccessViewModule),
  },
  {
    path: 'plans',
    canActivate: [termsGuard],
    loadChildren: () =>
      import('./workflow/planes/planes.module').then((m) => m.PlansModule),
    resolve: {
      resolver_plans: PlansResolverService,
      resolver_detail_plans: DetailPlansResolverService,
      resolve_user_plan: EmployeePlanResolver,
      resolve_change_plan:EmployeeChangePlanResolver,
      resolverBenefit: DataBenefitResolverService,
      resolverEmpleadoSAP:EmployeeSAPResolverService
    }
  },
  {
    path: 'form',
    loadChildren: () =>
      import(
        './workflow/benefit-application/employee-request-flow/employee-request-flow.module'
      ).then((m) => m.EmployeeRequestFlowModule),
      resolve:{
        resolverEmpleadoSAP:EmployeeSAPResolverService
      }
  },
  {
    path: 'my-requests',
    canActivate: [termsGuard],
    loadChildren: () =>
      import('./workflow/my-requests/my-requests.module').then(
        (m) => m.MyRequestsModule,
      ),
    resolve: {
      resolverRequest: DataRequestResolverService,
    },
  },
  { path: 'form/request-detail/:id', 
        component: ViewEditFormComponent, 
        canActivate: [termsGuard], 
        resolve: {
          resolver_request_details_id: DataRequestSolicitudIdResolverService,
          resolver_request_history_id: DataRequestHistoryResolverService
        }
      },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
